/** User administration (`/api/users`). Owner: settings-admin. Add keys; never rename. */
export const userKeys = {
  all: ['users'] as const,
  list: () => ['users', 'list'] as const,
  sessions: (userId: string) => ['users', 'detail', userId, 'sessions'] as const,
  /** `GET /api/users/lookup`: `{id, displayName}` for owner pickers (any signed-in user). */
  lookup: () => ['users', 'lookup'] as const,
};
